import { useState } from 'react'
import Projects from '../../api/projects'


const ClickHandler = () => {
  window.scrollTo(0, 0)
}

const ProjectSection = (props) => {
  const [activeCategory, setActiveCategory] = useState('all')

  // Get unique categories from projects
  const categories = [
    'all',
    ...new Set(Projects.map((project) => project.subTitle)),
  ]


  // Filter projects based on active category
  const filteredProjects =
    activeCategory === 'all'
      ? Projects
      : Projects.filter((project) => project.subTitle === activeCategory)
  return (
   
    <section className={'' + props.hclass}>
      <div className="container">
        <div className="title">
          {/* <h2 className="fade_bottom">Our Projects</h2> */}
        </div>

        
         <div className="service-wrap">
          {Projects.slice(0, 12).map((service, index) => (
            <div className="service-card" key={index}>
              <div className="card-content">
                <img src={service.pimg} alt={service.title} />
                {/* <img src={service.pimg} alt={service.title} /> */}
                {/* <h2>{service.title}</h2>
                <p>{service.description}</p> */}
              </div>
            </div>
          ))}
        </div>
       
      </div>
    </section>
  )
}
export default ProjectSection
